import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../store/actions/index';

class LogOut extends React.Component {

    constructor() {
        super();
    }

    componentDidMount() {
        this.props.clearAppData();
        this.props.onLogout(this.props.access_token);
    }

    render() {
        return <Redirect to="/" />
    }

}

const mapStateToProps = state => {
    return {
        access_token : state.auth.access_token,
        loading: state.auth.loading,
        error: state.auth.error,
        token_type: state.auth.token_type,
        isAuthenticated: state.auth.access_token !== null,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLogout: (access_token) => dispatch(actions.logout(access_token)),
        clearAppData : () => dispatch(actions.clearAppData())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogOut);